// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/common/jquery-3.6.0.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("/common/jquery.query.js", import.meta.url);
var ___HTML_LOADER_IMPORT_2___ = new URL("/common/jquery.json.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_3___ = new URL("/common/default.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_4___ = new URL("/2-choices/component-cp/main/index.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_5___ = new URL("./questions.js", import.meta.url);
var ___HTML_LOADER_IMPORT_6___ = new URL("/2-choices/component-cp/main/index.js", import.meta.url);
var ___HTML_LOADER_IMPORT_7___ = new URL("/2-choices/component-cp/main/answer-button.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_8___ = new URL("/common/timer.js", import.meta.url);
var ___HTML_LOADER_IMPORT_9___ = new URL("/2-choices/component-cp/footer-ponta.scss", import.meta.url);
// Module
var code = `<!DOCTYPE html>
<html lang="ja">
  <head
    prefix="og: https://ogp.me/ns# fb: https://ogp.me/ns/ fb# article: https://ogp.me/ns/article#"
  >
    
    <!---->
    <!--デフォルト値の設定-->




<meta charset="UTF-8" />
<meta
  name="viewport"
  content="width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1"
/>
<meta name="format-detection" content="telephone=no" />
<title>「美しくを、変えていく。」ヤーマン（YA-MAN）今なら20%OFFクーポン!</title>
<meta name="description" content="お金のミカタは、ためる(ポン活)・ふやす(運用)・そなえる(保険)・まなべるサービスを紹介する、“Ponta[ポンタ]“の公式金融総合サイトです" />
<link rel="index" href="index.htm" />
<!-- icon -->
<link
  rel="shortcut icon"
  type="image/vnd.microsoft.icon"
  href="/cmn/img/favicon.ico"
/>
<link rel="icon" type="image/x-icon" href="/cmn/img/favicon.ico" />
<link
  rel="apple-touch-icon"
  sizes="180x180"
  href="/cmn/img/apple-touch-icon.png"
/>
<!-- og -->
<meta property="og:url" content="https://www.finance.ponta.jp/2-choices/0012/" />
<meta property="og:type" content="website" />
<meta property="og:title" content="「美しくを、変えていく。」ヤーマン（YA-MAN）今なら20%OFFクーポン!" />
<meta property="og:description" content="お金のミカタは、ためる(ポン活)・ふやす(運用)・そなえる(保険)・まなべるサービスを紹介する、“Ponta[ポンタ]“の公式金融総合サイトです" />
<meta property="og:site_name" content="【Ponta】お金のミカタ" />
<meta property="og:image" content="https://www.finance.ponta.jp/cdn/img/ogp.png" />
<!-- Twitter -->
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:site" content="@Ponta" />

${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_0___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_1___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_2___}">${"<" + "/script"}>

<!-- StyleSheet -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_3___}" />

<!-- noto sans jp の読み込み -->
<link rel="preconnect" href="https://fonts.gstatic.com" />
<link
  rel="preload"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  as="style"
/>
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  media="print"
  onload="this.media = 'all'"
/>

<!-- corporate-logo の読み込み -->
<link rel="preload" href="/font/corporate-logo.css" as="style" />
<link
  rel="stylesheet"
  href="/font/corporate-logo.css"
  media="print"
  onload="this.media = 'all'"
/>

<!-- Google Tag Manager (loadイベント後に遅延読み込み) -->
<!-- 旧コード: Clarityとアニメーションの競合解消後に戻す
${"<" + "script"}>
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-P3QVP6P");
${"<" + "/script"}>
-->
${"<" + "script"}>
  window.dataLayer = window.dataLayer || [];
  window.addEventListener("load", function () {
    dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = document.getElementsByTagName("script")[0],
      j = document.createElement("script");
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=GTM-P3QVP6P";
    f.parentNode.insertBefore(j, f);
  });
${"<" + "/script"}>

<!-- Google広告 -->
${"<" + "script"}
  async
  src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2528660706528280"
  crossorigin="anonymous"
>${"<" + "/script"}>

    <meta name="robots" content="noindex" />
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_4___}" />
    ${"<" + "script"} src="${___HTML_LOADER_IMPORT_5___}">${"<" + "/script"}>
    ${"<" + "script"} src="${___HTML_LOADER_IMPORT_6___}">${"<" + "/script"}>
  </head>

  <body>
    <!-- Google Tag Manager (noscript) -->
<noscript
  ><iframe
    src="https://www.googletagmanager.com/ns.html?id=GTM-P3QVP6P"
    height="0"
    width="0"
    style="display: none; visibility: hidden"
  ></iframe
></noscript>
<!-- End Google Tag Manager (noscript) -->

    <div class="body-contents">
      <br />
      <main>
        <div class="bg-white hidden">
          <p id="question_index"></p>
          <h2 id="questionnaire"></h2>
          <div class="content">
            <div id="tmp_area" class="tmp_area">図または動画</div>
            <div id="content_area" class="content_area"></div>
          </div>
          <!--answer-button-->
          <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_7___}" />
${"<" + "script"} src="${___HTML_LOADER_IMPORT_8___}">${"<" + "/script"}>
<div class="answer-button">
  <a
    id="answer-button-yes"
    class="answer-button-yes timer-target"
    data-id="yes"
    data-start="2025-06-16T10:00:00+09:00"
    data-end="2025-08-15T18:00:00+09:00"
    >はい
  </a>
  <a
    id="answer-button-no"
    class="answer-button-no timer-target"
    data-id="no"
    data-start="2025-06-16T10:00:00+09:00"
    data-end="2025-08-15T18:00:00+09:00"
    >いいえ
  </a>
</div>

          <p class="explanation">
            全てのアンケートにご回答いただきPontaWebまたはau
            IDでログインする事でエントリーが完了します
          </p>
          <p id="announcement" class="announcement">
            ※次ページでPontaWebログインまたはau
            IDログインするとヤーマン特設サイトで利用できるクーポンが表示されます。<br />
            ※ログイン済みブラウザの場合はログインが省略されサービスページに直接遷移します<br />
          </p>
          <!-- footer-ponta -->
          <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_9___}" />
<div class="footer-ponta">©Ponta</div>

        </div>
      </main>
    </div>
  </body>
</html>
`;
// Exports
export default code;